import { useEffect } from 'react';

/**
 * Define document `click` handler callback while the event bubble outside of the spec(ref) container.
 * @param ref
 * @param onEvent The event callback
 * @example
 *  const ref = useRef(null);
 *  function onClickOutside() {
 *    setIsOpen(false);
 *  }
 *  useOutsideClick(ref, onClickOutside);
 * ....
 * <div ref={ref} />
 */
export function useOutsideClick(ref: any, onEvent: () => void) {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        onEvent();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onEvent, ref]);
}
